import styled from '@emotion/styled';

const Wrapper = styled.div`
  margin: 1.75rem 0;
`;

const Answer = styled.div`
  p {
    margin: 0;
  }
`;

export { Wrapper, Answer };
